import BaseComponent from './BaseComponent';
import Rails         from 'rails-ujs';

class Product extends BaseComponent {
  constructor(componentName){
    super(componentName);

    // Global object generated by the server in a rails partial
    if(window.pricesData) {
      this.loadPrices(pricesData.path, pricesData.ids);
      this.initBookProductListener(pricesData.ids.split('@'));
    }
  }

  init(component) {
    this.addCustomEvents(component);
  }

  addCustomEvents(component) {
    const product     = component.element;
    const amount      = component.element.getElementsByClassName('amount')[0];
    const inputNumber = component.element.querySelector(`input[type='number']`);
    const remove      = component.element.getElementsByClassName('btn--item-amount')[0];
    const add         = component.element.getElementsByClassName('btn--item-amount')[1];

    function updateUnits() {
      const units    = parseInt(product.getAttribute('data-units'));
      const minUnits = parseInt(amount.getAttribute('data-min-units'));
      // console.log('amount.value', amount.value);
      // console.log('units', units);

      if(parseInt(amount.value) !== units) {
        remove.href = updateQueryStringParameter(remove.href, 'units', Math.max(0, filterInt(amount.value, true) - minUnits))
        add.href    = updateQueryStringParameter(add.href, 'units', filterInt(amount.value, true) + minUnits)
      } else {
        remove.href = urlWithoutQueryParams(remove.href)
        add.href    = urlWithoutQueryParams(add.href)
      }
    }

    if(amount) {
      amount.addEventListener('keydown', (e) => {
        if( e.keyCode !== 9   || // Tab
            e.keyCode !== 27  || // Esc
            e.keyCode !== 13  || // Enter
            e.keyCode !== 110 || // Decimal point
            e.keyCode !== 190    // dot
        ) {
          if (
            e.keyCode == 16 || // Shift
            e.keyCode == 37 || // arrow left
            e.keyCode == 38 || // arrow top
            e.keyCode == 39 || // arrow right
            e.keyCode == 40    // arrow bottom
          ) {
            return;
          } else if (
            e.keyCode == 8  || // Delete
            e.keyCode == 46    // Suprimir
          ) {
            return;
          } else if (e.keyCode <= 105 && e.keyCode >= 96) { // Numbers in the numpad
            return;
          } else if ((e.keyCode < 48 || e.keyCode > 57) && e.keyCode !== 13) { // If is not a number or the Enter key, avoid
            e.preventDefault();
          } else {
            return;
          }
        } else {
          // Numbers 48-57 & Enter
          e.preventDefault();
        }
      });


      amount.addEventListener('keyup', (e) => {
        updateUnits();
        if (e.keyCode == 13) {  // Enter
          amountUpdatedActions.bind(this)();
        } else {
          inputNumber.value = amount.value;
          inputNumber.setAttribute('value', amount.value);
          return;
        }
      });

      // amount.addEventListener('blur', (e) => {
      //   console.warn('BLUR EVENT')
      //   amountUpdatedActions.bind(this)();
      // });

      function amountUpdatedActions() {
        if (amount.value.length == 0) {
          amount.value = 0;
          amount.setAttribute('value', 0);
        }
        const listener = add.getAttribute('data-listener') == 'true';
        const stock    = product.getAttribute('data-stock');

        if(amount.value > stock && listener) {
          // updating modal content
          const id    = product.getAttribute('data-product-id');
          const availableAt = product.getAttribute('data-available-at');
          this.updateModals({ id, stock, amount: amount.value, availableAt });

          // Open modal
          const modal = document.querySelector(`div[data-modal="${business ? 'book-product' : 'email-when-stock'}"]`);
          app.components.modalTrigger.openModal(modal);
        } else {
          const form = component.element.getElementsByClassName('form--add-to-cart')[0];
          Rails.fire(form, 'submit');
        }
      }
    }


    if (app.enhancedEcommerce) {
      const productLink = component.element.getElementsByClassName('product__content-link')[0];
      if (productLink) {
        productLink.addEventListener('click', e => {
          this.gtmProductClick(product);
        });
      }
    }
  }

  updateProduct(id, units, stock, soldOut, booked, business) {
    // console.table({ id, business, booked, stock, units });
    const products = this.getProducts(id);
    let   availableAt;

    for (let product of products) {
      // Remove sold out (in case warehouse just update item amount while user is navigating)
      product.classList.remove('sold-out');

      // Update amount value with the current units
      const amount = product.getElementsByClassName('amount')[0];
      product.setAttribute('data-units', units)
      if (amount) amount.value = units;

      // Reseting buy buttons
      const remove = product.getElementsByClassName('btn--item-amount')[0];
      const add    = product.getElementsByClassName('btn--item-amount')[1];

      if(remove) remove.href = urlWithoutQueryParams(remove.href);
      if (add)   add.href    = urlWithoutQueryParams(add.href);

      // Add class first time or remove if there are no units
      if(units > 0 && !product.classList.contains('product--added')) {
        product.classList.add('adding-product');

        setTimeout(() =>{
          product.classList.add('product--added');
          product.classList.remove('adding-product');
        }, 1100);
      // Remove product added if the user removed all the units from the cart
      } else if (units < 1) {
        product.classList.remove('product--added');
        // product.classList.remove('stock-limit');
        if (product.classList.contains('product--in-cart')) {
          const cartRow = product.parentElement;
          cartRow.classList.add('removing');

          setTimeout(() =>{
            cartRow.parentNode.removeChild(cartRow);
          }, 300);
        }
      }

      this.bookProductListener({ id, product, stock, units, booked, business })
    }
  }

  getProducts(id, first) {
    return document.querySelectorAll(`article[data-product-id='${id}']`);
  }

  initBookProductListener(ids) {
    for (let id of ids) {
      const products = this.getProducts(id);
      for (let product of products) {
        const units   = filterInt(product.getAttribute('data-units'), true);
        const stock   = filterInt(product.getAttribute('data-stock'), true);
        const booked  = units > stock;
        // console.table({ id, stock, units, booked, business })
        this.bookProductListener({ id, product, stock, units, booked, business })
      }
    }
  }

  bookProductListener(data) {
    const { id, product, stock, units, booked, business } = data;
    const add         = product.getElementsByClassName('btn--item-amount')[1];
    const amountTag   = product.getElementsByClassName('amount')[0];

    if(add) {
      if(units >= stock && !booked) {
        const amount = filterInt(amountTag.value, true);
        add.id     = id;
        add.stock  = stock;
        add.amount      = amount > units ? amount : false;
        add.availableAt = product.getAttribute('data-available-at');

        add.addEventListener('click', this.triggerModal);
        add.setAttribute('data-listener', true);
      } else {
        add.removeEventListener('click', this.triggerModal);
        add.setAttribute('data-listener', false);
      }
    }
  }

  triggerModal(e) {
    e.preventDefault();
    e.stopPropagation();

    // Update Modal content
    const id          = e.currentTarget.id;
    const stock       = e.currentTarget.stock;
    const amount      = e.currentTarget.amount;
    const availableAt = e.currentTarget.availableAt;

    app.components.product.updateModals({ id, stock, amount, availableAt });

    // Open modal
    const modal = document.querySelector(`div[data-modal="${business ? 'book-product' : 'email-when-stock'}"]`);
    app.components.modalTrigger.openModal(modal);
  }

  getProductData(id) {
    const product = document.querySelector(`article[data-product-id='${id}']`);
    const stock       = product.getAttribute('data-stock');
    const availableAt = product.getAttribute('data-available-at');

    return { id, stock, availableAt };
  }

  updateModals(data) {
    const { id, stock, availableAt, amount } = data;
    const bookProductModal    = document.querySelector('div[data-modal="book-product"]');
    const emailWhenStockModal = document.querySelector('div[data-modal="email-when-stock"]');

    // Updating emailWhenStock
    // Input with the proper id
    const form  = emailWhenStockModal.getElementsByClassName('form')[0];
    const input = form.getElementsByClassName('input-product-id')[0];
    input.value = id;

    // Content
    const emailWhenStockModalBody = emailWhenStockModal.getElementsByClassName('modal__body')[0];
    const withStock   = emailWhenStockModalBody.getElementsByClassName('with-stock')[0];
    const stockSpan   = withStock.getElementsByClassName('stock')[0];
    const withDate    = emailWhenStockModalBody.getElementsByClassName('with-date')[0];
    const withoutDate = emailWhenStockModalBody.getElementsByClassName('without-date')[0];
    const dateSpan    = withDate.getElementsByClassName('date')[0];

    dateSpan.textContent  = availableAt;
    stockSpan.textContent = stock;

    if(availableAt) {
      withDate.classList.remove('hidden');
      withoutDate.classList.add('hidden');
    } else {
      withDate.classList.add('hidden');
      withoutDate.classList.remove('hidden');
    }

    if(stock > 0) {
      withStock.classList.remove('hidden');
    } else {
      withStock.classList.add('hidden');
    }


    // Updating bookProduct (only for business)
    if(bookProductModal) {
      // href with the proper id and the stock
      const bookProductModalSubmit = bookProductModal.getElementsByClassName('btn--white')[0];
      const initialUrl  = bookProductModalSubmit.getAttribute('href');
      const cleanUrl    = urlWithoutSegments(initialUrl, 2)
      const finalUrl    = `${cleanUrl}${amount ? 'update' : 'add'}/${id}${amount ? `?units=${amount}` : ''}`;
      bookProductModalSubmit.setAttribute('href', finalUrl);

      // Content
      const bookProductModalHeader = bookProductModal.getElementsByClassName('modal__header')[0];
      const bookProductModalBody   = bookProductModal.getElementsByClassName('modal__body')[0];

      const titleWithStock    = bookProductModalHeader.getElementsByClassName('with-stock')[0];
      const titleWithoutStock = bookProductModalHeader.getElementsByClassName('without-stock')[0];

      const withStock    = bookProductModalBody.getElementsByClassName('with-stock')[0];
      const withoutStock = bookProductModalBody.getElementsByClassName('without-stock')[0];
      const stockSpan    = withStock.getElementsByClassName('stock')[0];
      stockSpan.textContent = stock;

      if(stock > 0) {
        titleWithStock.classList.remove('hidden');
        titleWithoutStock.classList.add('hidden');

        withStock.classList.remove('hidden');
        withoutStock.classList.add('hidden');
      } else {
        titleWithStock.classList.add('hidden');
        titleWithoutStock.classList.remove('hidden');

        withStock.classList.add('hidden');
        withoutStock.classList.remove('hidden');
      }
    }
  }

  loadPrices(url, ids) {
    app.ajax.rails(url, 'POST', `ids=${ids}`);
  }

  updatePrice(id, regularPrice, price, totalPrice, gtmPrice) {
    const products = this.getProducts(id);

    for (let product of products) {
      product.setAttribute('data-gtm-price', gtmPrice);

      const totalPrices   = product.getElementsByClassName('price--current-units');
      const oldPrices     = product.getElementsByClassName('price--old');
      const currentPrices = product.getElementsByClassName('price--current');

      for (let total of totalPrices) {
        total.innerHTML = totalPrice;
      }

      for (let currentPrice of currentPrices) {
        currentPrice.innerHTML = price;
      }

      for (let oldPrice of oldPrices) {
        oldPrice.innerHTML = regularPrice;
        regularPrice == price ? oldPrice.classList.add('hidden') : oldPrice.classList.remove('hidden');
      }
    }
  }


  updateFav(id, active) {
    const products = this.getProducts(id);

    for (let product of products) {
      const fav = product.getElementsByClassName('btn--fav')[0];
      active ? fav.classList.add('active') : fav.classList.remove('active');
    }
  }


  /////////////////////
  //                 //
  //   GTM METHODS   //
  //                 //
  /////////////////////

  gtmProductsImpressions() {
    let gtmProducts = [];
    const products  = document.getElementsByClassName('cmp-product');

    for (let product of products) {
      gtmProducts.push({
        'name'       : product.getAttribute('data-gtm-name'),
        'id'         : product.getAttribute('data-gtm-id'),
        'price'      : product.getAttribute('data-gtm-price'),
        'stock'      : product.getAttribute('data-gtm-stock'),
        'dimension7' : product.getAttribute('data-gtm-stock'),
        'brand'      : product.getAttribute('data-gtm-brand'),
        'category'   : product.getAttribute('data-gtm-category'),
        'variant'    : product.getAttribute('data-gtm-variant'),
        'list'       : product.getAttribute('data-gtm-list'),
        'position'   : product.getAttribute('data-gtm-position')
      });
    }

    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
      'ecommerce': {
        'currencyCode' : 'EUR',
        'impressions'  : gtmProducts
      }
    });
  }

  gtmProductClick(product) {
    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
      'event': 'productClick',
      'ecommerce': {
        'click': {
          'actionField': {'list': product.getAttribute('data-gtm-list')},
          'products': [{
            'name'     : product.getAttribute('data-gtm-name'),
            'id'       : product.getAttribute('data-gtm-id'),
            'price'    : product.getAttribute('data-gtm-price'),
            'brand'    : product.getAttribute('data-gtm-brand'),
            'category' : product.getAttribute('data-gtm-category'),
            'variant'  : product.getAttribute('data-gtm-variant'),
            'position' : product.getAttribute('data-gtm-position')
          }]
        }
      },
      // // Comment to allow user to use CMD + Click to open link in a new tab without updating the current one
      // 'eventCallback': function() {
      //   const productLink = product.getElementsByClassName('product__content-link')[0];
      //   if (!!productLink) document.location = productLink.href;
      // }
    });
  }

  gtmAddProductToCart(id, units) {
    const products = this.getProducts(id);
    const product  = products[0];

    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
      'event': 'add_to_cart',
      'ecommerce': {
        'items': [{
          'item_name'     : product.getAttribute('data-gtm-name'),
          'item_id'       : product.getAttribute('data-gtm-id'),
          'price'    : product.getAttribute('data-gtm-price'),
          'item_brand'    : product.getAttribute('data-gtm-brand'),
          'item_category' : product.getAttribute('data-gtm-category'),
          'item_variant'  : product.getAttribute('data-gtm-variant'),
          'quantity' : units
        }]
      }
    });
  }

  gtmRemoveProductFromCart(id, units) {
    const products = this.getProducts(id);
    const product  = products[0];

    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    dataLayer.push({
      'event': 'remove_from_cart',
      'ecommerce': {
        'items': [{
          'item_name'     : product.getAttribute('data-gtm-name'),
          'item_id'       : product.getAttribute('data-gtm-id'),
          'price'         : product.getAttribute('data-gtm-price'),
          'item_brand'    : product.getAttribute('data-gtm-brand'),
          'item_category' : product.getAttribute('data-gtm-category'),
          'item_variant'  : product.getAttribute('data-gtm-variant'),
          'quantity' : units
        }]
      }
    });
  }

}

export default Product;
